// Visit The Stimulus Handbook for more details 
// https://stimulusjs.org/handbook/introduction
// 
// This example controller works with specially annotated HTML like:

import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["slide"]

  initialize() {
    this.showCurrentSlide()
  }

  get index() {
    return parseInt(this.data.get("index"))
  }

  set index(value) {
    this.data.set("index",value)
    this.showCurrentSlide()
  }

  prev(e) { 
    if(this.index > 0)
      this.index--
    else
      this.index=this.slideTargets.length - 1 
  }
  next(e) { 
    if (this.index < (this.slideTargets.length - 1) )
      this.index++
    else
      this.index=0
  }

  showCurrentSlide() {
    this.slideTargets.forEach( (el, i) => { el.classList.toggle("slide--current", this.index == i) })
  }

  get name() {
    return this.nameTarget.value
  }
}
